import { compareInt } from '../util'
import Results from './results'
import DiscourseResult from './discourse_result'

const STRATEGIES = {
  recent (result) { return -result.id },
  mine (result) { return -result.get('score') },
  top (result1, result2) {
    // sort results descending when scores are identical
    if (result1.get('score') === result2.get('score')) {
      if (result1.id > result2.id) {
        return 1
      } else {
        return -1
      }
    } else {
      if (result1.get('score') > result2.get('score')) {
        return -1
      } else {
        return 1
      }
    }
  },
  netVotes (result1, result2) {
    // Compare by net votes first
    let comparison = compareInt(result1.get('net_votes'), result2.get('net_votes'))

    if (comparison !== 0) { return comparison }

    // Use upvotes as a tie breaker
    comparison = compareInt(result1.get('upvotes'), result2.get('upvotes'))
    if (comparison !== 0) {
      return comparison
    } else {
      // Use chronological order as the 2nd tie breaker
      return compareInt(result2.id, result1.id)
    }
  },
  netVotesRecentFirst (result1, result2) {
    // Compare by net votes first
    let comparison = compareInt(result1.get('net_votes'), result2.get('net_votes'))

    if (comparison !== 0) { return comparison }

    // Use upvotes as a tie breaker
    comparison = compareInt(result1.get('upvotes'), result2.get('upvotes'))
    if (comparison !== 0) {
      return comparison
    } else {
      // Use reverse chronological order as the 2nd tie breaker
      return compareInt(result1.id, result2.id)
    }
  }
}

// @namespace Model
export default class DiscourseResults extends Results {
  get model () { return DiscourseResult }
  set model (value) {}

  get sortStrategy () { return 'recent' }

  get strategies () { return STRATEGIES }

  changeSort (strategy) {
    this.comparator = this.strategies[strategy]
  }

  maxUpvotes () {
    return Math.max.apply(Math, this.pluck('upvotes').concat(0))
  }

  maxDownvotes () {
    return Math.max.apply(Math, this.pluck('downvotes').concat(0))
  }
}
